__webpack_require__.p = "/assets/turbo/83096d13/quellede/_next/";